// extracted by mini-css-extract-plugin
export default {"item":"SidebarItem_item__dMis7","link":"SidebarItem_link__iUPPZ","icon":"SidebarItem_icon__zf9NB careerIcon_careerIconSmallest__k974u careerIcon_careerIcon__Gj6VU"};